<!-- <p-panel header="{{ 'GROUPS' | translate }}" styleClass="p-panel-whitebg mb-3">-->
<p-accordionTab (selectedChange)="togglePanel($event)">
	<ng-template pTemplate="header">
		<div class="flex align-items-center justify-content-between w-full -my-3">
			<div class="font-semibold">{{ 'GROUPS' | translate }}</div>
			<!--<p-button *ngIf="online" pTooltip="{{ 'RELOAD' | translate }}" tooltipPosition="bottom" icon="pi cm-reload"
				size="large" (click)="$event.stopPropagation(); loadTimers()" [rounded]="false" [text]="true"
				severity="primary">
			</p-button>-->
		</div>
	</ng-template>
	<div class="grid">
		<div class="col-12">
			<p-table #tableGroupList dataKey="Id" [value]="groups" [lazy]="true" (onLazyLoad)="loadGroups($event)"
				[paginator]="true" [totalRecords]="totalRecords" [loading]="groupsLoading" [rows]="groupPageSize"
				[showCurrentPageReport]="true" currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}"
				[autoLayout]="true" responsiveLayout="stack">
				<ng-template pTemplate="caption">
					<div class="grid">
						<div [class]="actionLayout('left')">
							<p-button id="addGroup" label="{{ 'ADD_GROUP' | translate }}" (click)="addGroup()"
								[disabled]="groupsMemorySize>=groupsMaxMemorySize || !online || taskRunning" icon="pi cm-plus"
								[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary">
							</p-button>
						</div>
						<div [class]="actionLayout('center')">
							<div class="flex flex-column justify-content-center gap-2">
								<span class="flex align-items-center justify-content-center">
									<i class="pi cm-memory-storage mr-1"></i>
									{{'MEMORY_USAGE' | translate }}: {{groupsMemorySize}} / {{groupsMaxMemorySize}}
								</span>
								<p-progressBar [value]="getValueMemory()">
									<ng-template pTemplate="content" let-value>
										<span *ngIf="getValueMemory() >= 10">{{getValueMemory()}} %</span>
									</ng-template>
								</p-progressBar>
							</div>
						</div>
						<div [class]="actionLayout('right')">
							<span class="p-input-icon-left" [class]="dynamicInputSearchWidth()">
								<i class="pi cm-search"></i>
								<input [formControl]="searchFilter" pInputText type="text" id="customers-input-search"
									placeholder="{{ 'SEARCH' | translate }}" [ngClass]="dynamicInputSearchWidth()"
									maxlength="60" />
							</span>
						</div>
					</div>
				</ng-template>
				<ng-template pTemplate="header" class="flex align-items-center justify-content-center">
					<tr>
						<th style="width: 5rem"></th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'NAME' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'WEEKLYSCHEDULES_ACTIVE' | translate
								}}
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'SPECIALPLANNINGS_ACTIVE' |
								translate }}
							</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center"></div>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-group let-expanded="expanded">
					<tr>
						<td>
							<button type="button" pButton pRipple [pRowToggler]="group" class="p-button-rounded p-button-plain"
								[icon]="expanded ? 'pi cm-angle-down' : 'pi cm-angle-right'"></button>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'NAME' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ group.Name }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'WEEKLYSCHEDULES_ACTIVE' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ getNumWeeklySchedule(group) }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'SPECIALPLANNINGS_ACTIVE' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ getNumSpecialPlanning(group) }}
							</div>
						</td>
						<td>
							<span class="p-column-title"></span>
							<div class="flex flex-row justify-content-center align-items-center gap-1">
								<p-button pTooltip="{{ 'EDIT' | translate}}" tooltipPosition="bottom" icon="pi cm-pencil"
									[disabled]="!online || taskRunning" size="large" (click)="editGroup(group)" [rounded]="false"
									[text]="true" severity="secondary">
								</p-button>
								<p-button pTooltip="{{ 'DELETE' | translate}}" tooltipPosition="bottom" icon="pi cm-trash"
									[disabled]="!online || taskRunning" size="large" (click)="deleteGroup(group)"
									[rounded]="false" [text]="true" severity="danger">
								</p-button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="rowexpansion" let-group>
					<tr class="surface-400">
						<td colspan="12">
							<div class="grid">
								<div *ngIf="getNumWeeklySchedule(group)" class="col-12" [class]="onExtendedMobile() ? 'pb-0' : ''">
									<p class="font-bold mb-3 text-center">{{ 'WEEKLYSCHEDULES_ACTIVE' | translate }}</p>
									<div
										class="flex flex-row align-items-center justify-content-center gap-2 mb-3 border-100 border-bottom-2"
										[class]="onExtendedMobile() ? 'grid' : ''"
										*ngFor="let weeklySchedule of group.WeeklySchedules">
										<div class="font-semibold px-3" [class]="onExtendedMobile() ? 'col-12' : ''"
											[style]="getWidthLabelWs(group.WeeklySchedules)">{{ weeklySchedule.Name }}</div>
										<!--  DATE  -->
										<div class="flex flex-row align-content-center justify-content-center w-15_5rem"
											[class]="onExtendedMobile() ? 'col-12 pt-0' : ''">
											<p-button *ngFor="let day of daysOfWeekSchedule(weeklySchedule);"
												styleClass="p-button-weeklyschedulebgwhite w-2rem h-2rem flex justify-content-center hover:bg-primary cursor-auto"
												[text]="!day.Enable" [disabled]="!day.Enable"
												[severity]="day.Enable === true ? 'primary' : 'primary'"
												label="{{ day.Name | translate | firstLetter }}">
											</p-button>
										</div>
										<!--  TIME  -->
										<div class="flex flex-row align-items-center justify-content-center text-center gap-2"
											[class]="onExtendedMobile() ? 'col-12 py-0' : ''">
											{{ "DATE_FROM" | translate }}:
											<p class="font-bold">{{ weeklySchedule.TimeFrom+':00' }}</p>
										</div>
										<div class="flex flex-row align-items-center justify-content-center text-center gap-2"
											[class]="onExtendedMobile() ? 'col-12 pt-0' : ''">
											{{ "DATE_TO" | translate }}:
											<p class="font-bold">{{ weeklySchedule.TimeTo+':59' }}</p>
										</div>
									</div>
								</div>
								<div *ngIf="getNumSpecialPlanning(group)" class="col-12" [class]="onExtendedMobile() ? 'py-0' : ''">
									<p class="font-bold mb-3 text-center">{{ 'SPECIALPLANNINGS_ACTIVE' | translate }}</p>
									<div
										class="flex flex-row align-items-center justify-content-center gap-3 mb-3 border-100 border-bottom-2"
										*ngFor="let specialPlanning of group.SpecialPlannings"
										[class]="onExtendedMobile() ? 'grid' : ''">
										<div class="font-semibold" [class]="onExtendedMobile() ? 'col-12 pb-1' : ''">{{
											specialPlanning.Name }}</div>
										<!--  Access -->
										<div class="flex flex-row justify-content-start align-items-center"
											[class]="onExtendedMobile() ? 'col-12 justify-content-center py-1'  : ''">
											<p-tag
												[value]="specialPlanning.Access ? ('CONTROL_ACCESS_ENTER' | translate) : ('CONTROL_ACCESS_NOT_ENTER' | translate)"
												[severity]="specialPlanning.Access ? 'success' : 'danger'"></p-tag>
										</div>
										<!--  DATE  -->
										<div class="flex flex-row align-items-center justify-content-center text-center gap-2"
											[class]="onExtendedMobile() ? 'col-12 py-0' : ''">
											{{ "FROM" | translate }}:
											<p class="font-bold">{{ specialPlanning.DtFrom.split('T')[0]}}</p>
										</div>
										<div class="flex flex-row align-items-center justify-content-center text-center gap-2"
											[class]="onExtendedMobile() ? 'col-12 py-0' : ''">
											{{ "TO" | translate }}:
											<p class="font-bold">{{ specialPlanning.DtTo.split('T')[0]}}</p>
										</div>
										<!--  TIME  -->
										<div class="flex flex-row align-items-center justify-content-center text-center gap-2"
											[class]="onExtendedMobile() ? 'col-12 py-0' : ''">
											{{ "DATE_FROM" | translate }}:
											<p class="font-bold">{{ specialPlanning.DtFrom.split('T')[1]+':00' }}</p>
										</div>
										<div class="flex flex-row align-items-center justify-content-center text-center gap-2"
											[class]="onExtendedMobile() ? 'col-12 pt-0' : ''">
											{{ "DATE_TO" | translate }}:
											<p class="font-bold">{{ specialPlanning.DtTo.split('T')[1]+':59' }}</p>
										</div>
									</div>
								</div>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="12">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</p-accordionTab>
<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>